import { Button, IconPlus } from '@odekoteam/doppio';
import { Box, Flex, Heading } from 'theme-ui';

import ImportItemListModal from '@/components/Collection/ImportItemListModal';
import DataTable, { DataTableColumn } from '@/components/DataTable';
import useModal from '@/components/useModal';

export type CollectionItem = {
  name: string;
  itemId: string;
  brandName: string;
  warehouses: string;
  imgUrl: string | null;
};

const columns: DataTableColumn<CollectionItem>[] = [
  {
    header: 'Image',
    accessorKey: 'imgUrl',
    cell: (info) => {
      const value = info.getValue<string | null>();
      return value ? (
        <img
          alt="Item"
          src={value}
          style={{ width: 40, height: 40, objectFit: 'cover' }}
        />
      ) : (
        <div
          sx={{
            width: 40,
            height: 40,
            borderRadius: 10,
            backgroundColor: 'secondaryHighlight',
          }}
        />
      );
    },
  },
  { header: 'Name', accessorKey: 'name' },
  { header: 'Brand', accessorKey: 'brandName' },
  { header: 'Available Warehouses', accessorKey: 'warehouses' },
];

export default function CollectionItemsTable({
  items,
  disabled,
  onImport,
}: {
  disabled?: boolean;
  items: CollectionItem[];
  onImport: (ids: string[]) => void;
}) {
  const importItemListModal = useModal();

  return (
    <Box>
      <Flex sx={{ alignItems: 'end', justifyContent: 'space-between' }}>
        <Heading variant="headingSm">Items in Collection</Heading>
        <Button
          variant="primary"
          isDisabled={disabled}
          iconLeft={<IconPlus />}
          onPress={importItemListModal.toggle}
        >
          Bulk Upload Items
        </Button>
      </Flex>
      <DataTable<CollectionItem> data={items} columns={columns} />
      <ImportItemListModal
        onConfirm={onImport}
        onClose={importItemListModal.toggle}
        visible={importItemListModal.visible}
      />
    </Box>
  );
}
